import { createFileRoute } from "@tanstack/react-router";
import { SupporterListPage, modenmisupporterHead } from "@/pages/SupporterListPage";

export const Route = createFileRoute("/de/gegenuber-einem-mitstreiter")({
  head: () => modenmisupporterHead("de"),
  component: () => <SupporterListPage locale="de" />,
});
